import { useCallback, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import Select from "../../../../../components/shared/inputs/Select";
import useApi from "../../../../../utils/api";
import { getHourTypeColor } from "../../../../../utils/helpers/hourType";
import { renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";

function PayCodeSelect({ value, payGroup, companies, params = {}, onChange, ...props }: any) {
    const { authGet } = useApi();

    const { data } = useQuery({
        queryKey: ["/pay-code?pagination=false&withoutLookups=true", params],
        queryFn: ({ queryKey }) => {
            const [url, queryParams] = queryKey;
            return authGet(url as string, {
                params: queryParams
            });
        }
    });

    const options = useMemo(() => {
        let items = data?.result?.filter((item: any) => {
            if (item.code === value?.code) {
                return false;
            }
            if (
                item.allowedAllocationType === "company-allocation"
                && item.includeOrExcludeAllocated
                && item?.allowedCompanies?.length > 0
                && companies?.some((company: any) => {
                    return item.allowedCompanies.every((allowedCompany: any) => {
                        if (typeof allowedCompany === "string") {
                            return company.id === allowedCompany;
                        }
                        return company.id === allowedCompany.id;
                    });
                })
            ) {
                return false;
            }
            if (
                item.allowedAllocationType === "company-allocation"
                && !item.includeOrExcludeAllocated
                && item?.excludedCompanies?.length > 0
                && companies.some((company: any) => {
                    return item.excludedCompanies.every((excludedCompany: any) => {
                        if (typeof excludedCompany == "string") {
                            return company.id !== excludedCompany;
                        }
                        return company.id === excludedCompany.id;
                    });
                })
            ) {
                return false;
            }
            if (
                item.allowedAllocationType === "pay-group-allocation"
                && item.includeOrExcludeAllocated
                && item?.allowedPayGroups?.length > 0
                && !item.allowedPayGroups.includes(payGroup?.id)
            ) {
                return false;
            }
            if (
                item.allowedAllocationType === "pay-group-allocation"
                && !item?.includeOrExcludeAllocated
                && item?.excludedPayGroups?.length > 0
                && item.excludedPayGroups.includes(payGroup?.id)
            ) {
                return false;
            }
            return true;
        });
        return items || [];
    }, [data, value?.code, payGroup, companies]);

    const componentStyle = useMemo(() => {
        if (value) {
            return {
                borderColor: getHourTypeColor(value?.hourType),
                color: getHourTypeColor(value?.hourType),
                fontWeight: 600
            };
        }
        return {};
    }, [value]);

    const componentOnChange = useCallback((val: any) => {
        const payCode = options?.find((option: any) => option.code === val);
        onChange?.(payCode);
    }, [options, onChange]);

    return (
        <Select
            value={value?.code}
            style={componentStyle}
            onChange={componentOnChange}
            showSearch
            className="w-25"
            {...props}
        >
            {options.map((option: any) => (
                <Select.Item
                    key={option.code}
                    value={option.code}
                >
                    <span
                        className="inline-block w-2.5 h-2.5 border rounded-full shrink-0"
                        style={{
                            backgroundColor: getHourTypeColor(option.hourType),
                            borderColor: getHourTypeColor(option.hourType),
                        }}
                    />
                    <span className="truncate">{renderSettingsResourceLabel(option)}</span>
                </Select.Item>
            ))}
        </Select>

    );
}

export default PayCodeSelect;
